__turbopack_context__.v({
  "askFill": "SearchAskDemo-module__DOhlta__askFill",
  "assistant": "SearchAskDemo-module__DOhlta__assistant",
  "assistantHead": "SearchAskDemo-module__DOhlta__assistantHead",
  "column": "SearchAskDemo-module__DOhlta__column",
  "empty": "SearchAskDemo-module__DOhlta__empty",
  "filters": "SearchAskDemo-module__DOhlta__filters",
  "frame": "SearchAskDemo-module__DOhlta__frame",
  "mobileBack": "SearchAskDemo-module__DOhlta__mobileBack",
  "mobileBar": "SearchAskDemo-module__DOhlta__mobileBar",
  "mobilePanel": "SearchAskDemo-module__DOhlta__mobilePanel",
  "panels": "SearchAskDemo-module__DOhlta__panels",
  "prompt": "SearchAskDemo-module__DOhlta__prompt",
  "promptActions": "SearchAskDemo-module__DOhlta__promptActions",
  "promptIcon": "SearchAskDemo-module__DOhlta__promptIcon",
  "promptText": "SearchAskDemo-module__DOhlta__promptText",
  "promptTitle": "SearchAskDemo-module__DOhlta__promptTitle",
  "side": "SearchAskDemo-module__DOhlta__side",
  "sideHead": "SearchAskDemo-module__DOhlta__sideHead",
  "switch": "SearchAskDemo-module__DOhlta__switch",
  "tall": "SearchAskDemo-module__DOhlta__tall",
  "working": "SearchAskDemo-module__DOhlta__working",
});
